import { render, staticRenderFns } from "./SwvDatenschutz.vue?vue&type=template&id=61f00436"
import script from "./SwvDatenschutz.vue?vue&type=script&lang=js"
export * from "./SwvDatenschutz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports